const auz = (props)=>{
    return props.children;
}

export default auz;